import { create } from 'zustand';

const usePasswordResetStore = create((set, get) => ({
  // Password reset flow state
  passwordResetFlow: 0, // 0: login, 0.5: request reset, 1: enter code, 2: success
  resetEmail: '',
  resetCode: '',
  newPassword: '',
  
  // Actions
  setPasswordResetFlow: (flow) => set({ passwordResetFlow: flow }),
  
  setResetEmail: (email) => set({ resetEmail: email }),
  
  setResetCode: (code) => set({ resetCode: code }),
  
  setNewPassword: (password) => set({ newPassword: password }),
  
  // Reset all password reset state
  resetPasswordResetState: () => set({
    passwordResetFlow: 0,
    resetEmail: '',
    resetCode: '',
    newPassword: '',
  }),
  
  // Navigation helpers
  goToResetRequest: () => set({ passwordResetFlow: 0.5 }),
  
  goToCodeEntry: () => set({ passwordResetFlow: 1 }),
  
  goToSuccess: () => set({ passwordResetFlow: 2 }),
  
  goBackToLogin: () => set({
    passwordResetFlow: 0,
    resetEmail: '',
    resetCode: '',
    newPassword: '',
  }),
}));

export default usePasswordResetStore;